import { render, staticRenderFns } from "./SrmOrder.vue?vue&type=template&id=bf8a39f0&scoped=true"
import script from "./SrmOrder.vue?vue&type=script&lang=js"
export * from "./SrmOrder.vue?vue&type=script&lang=js"
import style0 from "./SrmOrder.vue?vue&type=style&index=0&id=bf8a39f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8a39f0",
  null
  
)

export default component.exports